import dynamic from 'next/dynamic';

const LogoOnlineAll = dynamic(
  () => import('../../ui/iconComponents/LogoOnlineAll'),
  {
    ssr: false,
  },
);
const LogoOnlineBusiness = dynamic(
  () => import('../../ui/iconComponents/LogoOnlineBusiness'),
  {
    ssr: false,
  },
);
const LogoOnlineClient = dynamic(
  () => import('../../ui/iconComponents/LogoOnlineClient'),
  {
    ssr: false,
  },
);
const LogoOnlineTherapist = dynamic(
  () => import('../../ui/iconComponents/LogoOnlineTherapist'),
  {
    ssr: false,
  },
);

const LogoMedsiXPogovorim = dynamic(
  () => import('../../ui/iconComponents/LogoMedsiXPogovorim'),
  {
    ssr: false,
  },
);

export const LOGOTYPES = {
  all: <LogoOnlineAll width={113} height={30} />,
  client: <LogoOnlineClient width={113} height={30} />,
  therapist: <LogoOnlineTherapist width={113} height={30} />,
  business: <LogoOnlineBusiness width={113} height={30} />,
  medsi: <LogoMedsiXPogovorim width={'auto'} height={20} />,
};
